/**
 * Production Environment Configuration
 * Used for production deployment
 */

export const productionConfig = {
  environment: 'production',
  hostname: 'provisioning-admin.strong.blue', // Update with actual production hostname

  api: {
    baseUrl: '/api',
    firmwareBaseUrl: 'http://provisioning.strong.blue',
  },

  oauth: {
    clientId: 'provisioning-prod',
    redirectUri: 'https://provisioning-admin.strong.blue/auth/callback',
    authUrl: 'https://sso.strong.blue/realms/anep-architecture/protocol/openid-connect/auth',
    tokenUrl: 'https://sso.strong.blue/realms/anep-architecture/protocol/openid-connect/token',
  },

  ui: {
    title: 'StrongBlue Device Provisioning',
    logoUrl: '/logo.jfif',
    companyName: 'Strong Blue',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: false, // Disable debug in production
  },
} as const;

export default productionConfig;